import { STM } from '../context/types';

export const it_itStatements : STM[]  = [
  {
    "id":1,
    "valueKey": "samen1",
    "title":"si lavora spesso insieme",
    "title_360_leadership": "stimola il lavoro in squadra",
    "title_360_workenv": "si lavora spesso insieme",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"gli interessi del team vengono prima degli interessi dei singoli",
    "title_360_leadership": "favorisce il successo dell'équipe prima del suo",
    "title_360_workenv": "gli interessi del team vengono prima degli interessi dei singoli",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"uno fa del proprio meglio per il team",
    "title_360_leadership": "si impegna per la sua squadra",
    "title_360_workenv": "si fa del proprio meglio per la squadra",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"un'opinione personale non è condivisa se può portare a un conflitto",
    "title_360_leadership": "non esprime la sua opinione se ciò potrebbe portare a un conflitto",
    "title_360_workenv": "un'opinione personale non è condivisa se può portare a un conflitto",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"viene fatto ogni sforzo per mantenere l'armonia",
    "title_360_leadership": "fa tutto per evitare le controversie",
    "title_360_workenv": "si fa tutto il possibile per mantenere la pace",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"le regole e le norme esistenti sono seguite scrupolosamente",
    "title_360_leadership": "si assicura che si rispettino le regole e le norme",
    "title_360_workenv": "si seguono con precisione le regole e le norme esistenti",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"le persone sono rispettate da colleghi e manager",
    "title_360_leadership": "garantisce un ambiente in cui si rispettano reciprocamente",
    "title_360_workenv": " le persone sono rispettate dai colleghi e dai manager",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"il duro lavoro viene apprezzato",
    "title_360_leadership": "riconosce il lavoro fatto",
    "title_360_workenv": "si riconosce il lavoro duro",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"l'impegno viene valorizzato e apprezzato",
    "title_360_leadership": "valorizza l'impegno profuso",
    "title_360_workenv": "l'impegno è valorizzato e apprezzato",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"uno fa sempre la cosa giusta per gli altri",
    "title_360_leadership": "è benevolo e rispettoso",
    "title_360_workenv": "si fa sempre il giusto verso gli altri",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"uno contribuisce al benessere degli altri",
    "title_360_leadership": "favorisce un ambiente in cui ogni membro si sente bene",
    "title_360_workenv": "si contribuisce al benessere degli altri",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"le persone si aiutano tra loro",
    "title_360_leadership": "favorisce un clima di solidarietà",
    "title_360_workenv": "le persone si aiutano reciprocamente",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"ciascuno è trattato allo stesso modo",
    "title_360_leadership": "tratta tutti in modo equo",
    "title_360_workenv": "tutti sono trattati in modo uguale",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"età, provenienza o genere non hanno importanza",
    "title_360_leadership": "non fa differenze in base all'età, all'origine o al sesso",
    "title_360_workenv": "non conta l'età, l'origine o il sesso",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"uno è giudicato dalle proprie azioni, non dal carattere",
    "title_360_leadership": "ci valuta sulla base delle nostre azioni",
    "title_360_workenv": "si giudica per le azioni, non per la personalità",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"è possibile, per la maggior parte, agire per conto proprio",
    "title_360_leadership": "fa in modo che ogni membro determini in gran parte lui stesso cosa fare",
    "title_360_workenv": "è possibile, per lo più, agire da sé",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"uno può decidere il proprio metodo di lavoro",
    "title_360_leadership": "ci lascia decidere come lavorare",
    "title_360_workenv": "si può determinare il proprio metodo di lavoro",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"uno può pianificare come fare il proprio lavoro",
    "title_360_leadership": "ci lascia in gran parte decidere il nostro orario di lavoro",
    "title_360_workenv": "si può pianificare da sé come fare il proprio lavoro",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"posso influenzare il comportamento di altri",
    "title_360_leadership": "influenza il mio lavoro",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"sono l'unico a decidere sulle cose da fare",
    "title_360_leadership": "dice cosa deve essere fatto",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"decido io ciò che accade",
    "title_360_leadership": "decide cosa deve essere fatto",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"c'è organizzazione e regolarità",
    "title_360_leadership": "garantisce la struttura e la regolarità",
    "title_360_workenv": "c'è struttura e regolarità",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"solitamente le cose accadono come previsto",
    "title_360_leadership": "si assicura che le cose si svolgano in generale come pianificato",
    "title_360_workenv": "le cose si svolgono generalmente come pianificato",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"i valori e i modi di pensare tradizionali possono essere mantenuti",
    "title_360_leadership": "garantisce il rispetto dei valori e delle tradizioni",
    "title_360_workenv": "si possono mantenere i valori e le tradizioni",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"è possibile fare del proprio meglio",
    "title_360_leadership": "ci incoraggia a dare il meglio di noi stessi",
    "title_360_workenv": "è possibile fare del proprio meglio",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"uno può dimostrare tutto il proprio potenziale",
    "title_360_leadership": "ci incoraggia a mostrare cosa possiamo fare",
    "title_360_workenv": "si può dimostrare il proprio potenziale completo",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"uno può eccellere nel proprio lavoro",
    "title_360_leadership": "ci incoraggia a eccellere nel lavoro che facciamo",
    "title_360_workenv": "si può eccellere nel proprio lavoro",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"uno può apprendere di continuo cose nuove",
    "title_360_leadership": "ci incoraggia alla formazione continua",
    "title_360_workenv": "si può imparare continuamente nuove cose",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"uno può approfondire la propria conoscenza",
    "title_360_leadership": "ci incoraggia a approfondire le nostre competenze",
    "title_360_workenv": "si può approfondire la conoscenza",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"uno può ampliare di continuo il proprio sviluppo personale",
    "title_360_leadership": "aiuta gli altri a svilupparsi",
    "title_360_workenv": "si può sviluppare personalmente continuamente",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"viene consegnato un lavoro di buona qualità",
    "title_360_leadership": "si assicura che la squadra produca un lavoro di qualità",
    "title_360_workenv": "si produce lavoro di alta qualità",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"i clienti e/o altri nel business sono rispettati",
    "title_360_leadership": "ci incoraggia attivamente a rispettare i clienti e le altre relazioni",
    "title_360_workenv": "si rispettano i clienti e/o gli altri soggetti del business",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"uno ha considerazione per le persone, la sicurezza e l'ambiente",
    "title_360_leadership": "si assicura che si tenga d'occhio l'individuo, la sicurezza e l'ambiente",
    "title_360_workenv": "si tiene conto delle persone, della sicurezza e dell'ambiente",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"ci si assume la responsabilità delle proprie azioni",
    "title_360_leadership": "si assicura che si assume la responsabilità delle azioni",
    "title_360_workenv": "si assume la responsabilità delle azioni",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"le persone sono oneste",
    "title_360_leadership": "è onesto",
    "title_360_workenv": "le persone sono oneste",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"la riservatezza viene rispettata",
    "title_360_leadership": "tratta con cura le informazioni personali e confidenziali",
    "title_360_workenv": "si rispetta la confidenzialità",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"si sperimentano cose nuove",
    "title_360_leadership": "ci incoraggia a provare nuove modalità di lavoro",
    "title_360_workenv": "si possono provare nuove cose",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"uno ha molte nuove esperienze",
    "title_360_leadership": "ci incoraggia a acquisire nuove esperienze",
    "title_360_workenv": "si hanno molte nuove esperienze",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"si cercano le sfide",
    "title_360_leadership": "ci stimola a cercare nuovi sfidanti",
    "title_360_workenv": "si possono cercare nuovi sfidanti",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"uno prende l’iniziativa di affrontare gli incarichi",
    "title_360_leadership": "ci incoraggia a iniziare da sé le attività",
    "title_360_workenv": "si prende l'iniziativa per affrontare le attività",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"viene data alta priorità a fare il possibile per ottenere risultati",
    "title_360_leadership": "si assicura che i risultati siano raggiunti",
    "title_360_workenv": "si dà alta priorità a fare il possibile per ottenere risultati",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"viene compiuto ogni sforzo possibile per conseguire gli obiettivi",
    "title_360_leadership": "fa tutto il possibile per raggiungere gli obiettivi",
    "title_360_workenv": "si fa tutto il possibile per raggiungere gli obiettivi",
    "preferredType": "leadership"
  }
]
export const extra360It_ItStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'prende decisioni',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'rispetta e valorizza le differenze tra i membri del team',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'fornisce feedback costruttivi',
      preferredType: 'leadership',
    },
]
